import React from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'

type Props = {
  handleloginModal?: () => void
}

const UniqueInsights = ({handleloginModal}: Props) => {
  return (
    <div className='row'>
      <div className='col-md-12'>
        <div
          className='card h-100 bgi-no-repeat bgi-size-cover card-xl-stretch mb-5 mb-xl-8 border-0 border-radious-0'
          style={{
            backgroundImage: `url('${toAbsoluteUrl('/media/misc/bg-2.jpg')}')`,
            borderRadius: 0,
          }}
        >
          <div className='card-body container  d-flex flex-column justify-content-between'>
            <div className='text-white fw-bolder fs-2'>
              <h2 className=' display-5 fw-bolder text-white mb-2'>
                We now live in a remote-first world{' '}
              </h2>
              <h4 className='text-white me-3 mt-3'>
                Companies are in competition to garner the benefits of remote engineering talent
              </h4>
            </div>

            <div className='row my-7'>
              <div className='col-md-6 '>
                <div className='row'>
                  <div className='col-sm-6 my-7'>
                    <div className='text-white bg-with-op h3 py-3 ' style={{}}>
                      <span className='svg-icon svg-icon-2 svg-icon-primary'>
                        <KTSVG
                          path='/media/icons/duotune/general/gen002.svg'
                          className='svg-icon-1 svg-icon-primary me-3'
                        />
                      </span>
                      Planetary pool of software developers
                    </div>
                  </div>
                  <div className='col-sm-6 my-7'>
                    <div className='text-white bg-with-op h3 py-3 ' style={{}}>
                      <span className='svg-icon svg-icon-2 svg-icon-primary'>
                        <KTSVG
                          path='/media/icons/duotune/general/gen026.svg'
                          className='svg-icon-1 svg-icon-primary me-3'
                        />
                      </span>
                      Millions of untapped Silicon Valley caliber engineers
                    </div>
                  </div>

                  <div className='col-sm-6 my-7'>
                    <div className='text-white bg-with-op h3 py-3 ' style={{}}>
                      <span className='svg-icon svg-icon-2 svg-icon-primary'>
                        <KTSVG
                          path='/media/icons/duotune/general/gen049.svg'
                          className='svg-icon-1 svg-icon-primary me-3'
                        />
                      </span>
                      Proven success of distributed teams
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <button
              onClick={handleloginModal}
              className='align-self-start btn btn-link bg-transparent text-primary fw-bold'
            >
              Become a lucian developer
              <span className='svg-icon svg-icon-2 svg-icon-primary'>
                <KTSVG
                  path='/media/icons/duotune/arrows/arr071.svg'
                  className='svg-icon-1 svg-icon-primary'
                />
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UniqueInsights
